import Direction from '@shared/types/enums/direction';
import styled from 'styled-components';

const UpgradablePlanContainer = styled.div.attrs({
  id: 'upgradablePlanContainer',
})<{ direction?: Direction }>`
  display: flex;
  flex-direction: ${(props) =>
    props.direction === Direction.VERTICAL ? 'column' : 'row'};
  justify-content: center;
`;

export default UpgradablePlanContainer;
